import AccionActions from "./AccionActions";

const AccionRow = ({ accion, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{accion.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(accion.frase || "-"),
        }}
      />
      <td>{accion.area_texto || accion.area || "-"}</td>
      <td>{accion.talento_nombre || accion.talento || "-"}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            accion.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {accion.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <AccionActions accion={accion} />
        </span>
      </td>
    </tr>
  );
};

export default AccionRow;
